module.exports = __webpack_public_path__ + "static/media/MLExample1.cc250fe3.jpg";